<nav class="navbar navbar-default blue-bg">
    <div class="container container-fluid">
        <div class="navbar-header">
            <h1 class="navbar-brand">Lista wniosków do podpisu
                <i class="pi pi-info-circle" pTooltip="Wniosek zostanie automatycznie usunięty w ciągu 7 dni od daty utworzenia" aria-hidden="true"></i>
            </h1>
        </div>
    </div>
</nav>

<p-table [value]="proposals" responsiveLayout="scroll" class="flex-1">
    <ng-template pTemplate="header">
        <tr>
            <th scope="col">Numer wniosku</th>
            <th scope="col">Nazwa firmy</th>
            <th scope="col">NIP/KRS</th>
            <th scope="col">Data utworzenia</th>
            <th scope="col"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td class="text-align-center" colspan="5">
                Nie znaleziono wniosków
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-proposal>
        <tr>
            <td>{{proposal.docNo}}</td>
            <td>{{proposal.company}}</td>
            <td>{{proposal.companyId}}</td>
            <td>{{proposal.creationDate}}</td>
            <td class="grid justify-content-right row-gap">
                <p-fileUpload #spForm [customUpload]="true" [auto]="true"
                              (uploadHandler)="uploadHandler($event, spForm, proposal.id)"
                              chooseIcon="pi pi-file-pdf"
                              chooseLabel="Załącz"
                              (onRemove)="fileRemove(spForm)"
                              mode="basic"
                              pTooltip="Załącz podpisany wniosek">
                </p-fileUpload>&nbsp;
                <p-button pRipple type="button" icon="pi pi-pencil" label="Podpisz" pTooltip="Podpisz wniosek" (onClick)="signProposal(proposal)"></p-button>&nbsp;
            </td>
        </tr>
    </ng-template>
</p-table>

<br/>
<div class="flex">
    <p-button label="Wybór wniosku" icon="pi pi-backward" iconPos="left" styleClass="ml" (click)="chooseForm()"></p-button>
</div>

<p-blockUI [blocked]="blockUI">
    <p-progressSpinner></p-progressSpinner>
</p-blockUI>
